// Common Service Request templates (workflow doc: "Use templates for repetitive SR types")
// Each template prefills the SR creation form. Users can still edit before submitting.
export const SR_TEMPLATES = [
  {
    name: "Password reset",
    request_type: "general",
    category: "Access Management",
    title: "Password reset request",
    description: "Please reset my password.\n\n• Username: \n• System (e.g. SAP, Email, Domain): \n• Last successful login (approx): ",
  },
  {
    name: "New account / SAP access",
    request_type: "access",
    category: "Access Management",
    title: "New SAP / system access for [name]",
    description: "Requesting new access for an employee.\n\n• Full name: \n• Department: \n• Job title: \n• Systems needed (e.g. SAP, VPN, Email): \n• Reason for access: \n• Reports to: ",
  },
  {
    name: "Hardware: replace mouse / keyboard",
    request_type: "general",
    category: "Hardware Support",
    title: "Replacement peripheral request",
    description: "Need a replacement peripheral.\n\n• Device type (mouse/keyboard/headset/etc.): \n• Reason (faulty / lost / new starter): \n• Pickup or delivery location: ",
  },
  {
    name: "VPN access",
    request_type: "access",
    category: "Network & Infrastructure",
    title: "VPN access",
    description: "Requesting VPN access.\n\n• Reason: \n• Hours / locations expected: \n• Will personal device be used? Y/N: ",
  },
  {
    name: "Printer setup",
    request_type: "general",
    category: "Hardware Support",
    title: "Printer setup",
    description: "Set up a printer for my workstation.\n\n• Printer name / location (if known): \n• Workstation hostname: \n• Plant: ",
  },
  {
    name: "Software install",
    request_type: "general",
    category: "Software Support",
    title: "Software installation request",
    description: "Please install a software on my workstation.\n\n• Software & version: \n• Business justification: \n• License available? Y/N: ",
  },
  {
    name: "Email distribution list",
    request_type: "general",
    category: "Other Applications",
    title: "Email distribution list change",
    description: "Add / remove a member to a DL.\n\n• DL email: \n• Add or Remove: \n• Member email(s): ",
  },
  {
    name: "Access offboarding",
    request_type: "access",
    category: "Access Management",
    title: "Access termination for departing employee",
    description: "Disable all access for a departing employee.\n\n• Full name: \n• Last working day: \n• Manager: \n• Specific systems to revoke: ",
  },
];
